import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TimesheetGapRow } from '@evorait/pace-core';
import { TranslateModule } from '@ngx-translate/core';
import { formatRowDuration } from './row-duration';

/**
 * Time the timesheet does not account for.
 *
 * The one row that asks for something rather than showing data: it has nothing to edit, because a
 * gap is the absence of an entry. The user closes it by adding a manual entry, which is a
 * structural change and so goes straight to the store rather than through the form.
 */
@Component({
    selector: 'pace-timesheet-gap-row',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './timesheet-gap-row.component.html',
    styleUrl: './timesheet-row.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimesheetGapRowComponent {
    /** the unaccounted span */
    public readonly row = input.required<TimesheetGapRow>();

    /** whether the timesheet may still be changed at all */
    public readonly readonly = input(false);

    /**
     * Whether to offer continuing the travel-back leg this gap follows, instead of only a plain
     * entry. Decided by the page, which knows the config.
     */
    public readonly canAddTravelBack = input(false);

    /** the user asked to account for this span */
    public readonly addEntry = output<void>();

    /** the user asked to account for this span as another leg of travel back */
    public readonly addTravelBack = output<void>();

    /** the gap's span as `HH:mm`, so its size is visible before deciding to fill it */
    protected readonly duration = computed(() => formatRowDuration(this.row().start, this.row().end));
}
